module.exports = __webpack_public_path__ + "static/Gotham-Bold-bd9720042425c185ea1cbe4b483039f5.woff2";